import Overview from './overview';
import Settings from './settings';

export default {
  Overview,
  Settings,
};
